import { Global } from '@emotion/react';
import React, { createContext, useContext } from 'react';
import { V5Styles } from './GlobalCss/V5Styles';
import { PlatformStyles } from './GlobalCss/PlatformStyles';
const ThemeContext = createContext({
    isRebrand: false,
    isPlatform: false,
});
export const useTheme = () => {
    const { isRebrand, isPlatform } = useContext(ThemeContext);
    return { isRebrand, isPlatform };
};
export const REBRAND_COOKIE = '__tnp';
export const PLATFORM_COOKIE = '__tzp';
export const GlobalStylesProvider = ({ children, isPlatform, isRebrand, }) => {
    return (React.createElement(ThemeContext.Provider, { value: { isRebrand, isPlatform } },
        React.createElement(Global, { styles: isPlatform ? PlatformStyles : V5Styles }),
        children));
};
//# sourceMappingURL=GlobalStylesProvider.js.map
// @zapier/global-styles-provider@0.5.3 (3a3e46256)
